import React, { Component } from 'react'
import "./productinfo.scss";
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import { Map, Marker } from 'react-amap';
import { getApiActivityInfo , getApiGeoCodeAddress } from '../../axios/api';
import { UrlSearch , get } from '../../axios/localstorage';
import { Carousel , message } from 'antd';
import QRCode from 'qrcode.react'

export default class productinfo extends Component {

    state = {
        content:"<img alt='' src='/www/assets/imgs/ccc.png' />",
        showSwiper:false,
        arr:[{},{},{},{}],
        timer:"",
        activeIndex:0,
        position:{ 
            longitude:116.314507,
            latitude:39.998272,
        },
        home:{},
        list:[
            {path:"/www/assets/imgs/video.mp4",id:1},
            {path:"/www/assets/imgs/video.mp4",id:2},
            {path:"/www/assets/imgs/video.mp4",id:3},
        ],
        banner:[],
        data:[],
        id:"",
        alert:false,
        share_url:"",
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    componentWillMount(){
        window.scroll(0,0);

        let id = UrlSearch('id');

        this.setState({
            share_url:window.location.href,
            id
        })


        getApiActivityInfo({id})
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                let type =data.type;
                console.log(data);
                let banner = data.images;
                // for(var i=0;i<data.length;i++){
                //     if(data[i].type === 7){
                //         this.getPosition(data[i].address);
                //     }
                // }

                // document.title = data.info.title;
                // document.getElementsByName('description')[0].content = data.info.info;

                this.setState({
                    data:data.data,
                    banner,
                    id,
                    type
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }


    gotoSlide=(num)=>{
        this.refs['bslide'].goTo(num);
    }

    getPosition=(address)=>{

        let param = {
            key:"e9a78a88cf29aa73cd87a0a373212358",
            address:address
        }

        getApiGeoCodeAddress(param)
        .then( req =>{
            console.log(req.data)
            if(req.data.status == 1){
                let data = req.data.geocodes[0];
                console.log(data);
                let location = data.location.split(',');
                this.setState({
                    position:{ 
                        longitude:location[0],
                        latitude:location[1],
                    }
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    componentDidMount(){
        window.scroll(0,0)

        setTimeout(()=>{
            this.setState({
                showSwiper:true,
            })
        },200);
    }

    componentWillUnmount(){
        console.log(656);

        clearInterval(this.state.timer);

        this.setState({
            showSwiper:false,
        })

        console.log(666);
    }

    handleSlideChange=()=>{
        const swiper = document.querySelector('.swiper-container').swiper;
  

        let activeIndex = swiper.activeIndex;
        this.initSwiperItem(activeIndex);
    }

    gotoNext=()=>{

        if(!this.state.showSwiper){
            return false;
        }

        const swiper = document.querySelector('.swiper-container').swiper;
        swiper.slideNext();//slideTo

        let activeIndex = swiper.activeIndex;
        this.initSwiperItem(activeIndex);
    }

    initSwiperItem=(activeIndex)=>{
        
        console.log(activeIndex%4);
        
        let swpierBox = document.getElementById('swpierBox')
        let swiperItem = swpierBox.getElementsByClassName('swiper-slide');

        console.log(swiperItem);

        if(swiperItem.length <=0){
            return false;
        }


        // console.log('initSwiperItem');

        for(var i=0;i<swiperItem.length;i++){
            // swiperItem[i].getElementsByTagName('span')[0].style.opacity = '0';
            swiperItem[i].style.opacity='1';
            swiperItem[i].style.transformOrigin='left';
            swiperItem[i].style.zIndex=0;
        }

        swiperItem[activeIndex+1].style.transform='scale(1,1)';
        swiperItem[activeIndex+1].style.opacity='1';
        swiperItem[activeIndex+1].style.zIndex=2;
        swiperItem[activeIndex].style.transform='scale(.76) translateX(400px)';
        swiperItem[activeIndex].style.opacity='.6';
        swiperItem[activeIndex+2].style.transform='scale(.76,.76) translateX(-200px)';
        swiperItem[activeIndex+2].style.opacity='.6';

        this.setState({
            activeIndex
        })
    }


    render() {
        return (
            <div className="productinfo">
                <Header type={8} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p className='i_point' onClick={()=>{this.gotoPage('/activity')}}>科创活动</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>活动详情</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="h_banner" hidden={this.state.banner.length === 0} onClick={()=>{
                    
                    // if(!get('token')){  
                    //     message.info("请先登录");
                    //     this.gotoPage('/login')
                    //     return false;
                    // }
                    
                    this.gotoPage('/productSignup?id='+this.state.id)}}>
                    <Carousel ref="bslide" dots={false} draggable={true} afterChange={(index)=>{this.onChange(index)}} autoplay={true} autoplaySpeed={3000}>
                        {
                            this.state.banner.map((item,index)=>{
                                return <div className='item' key={index}>
                                            <div className="bg" style={{backgroundImage:"url('"+item+"')"}}></div>
                                        </div>
                            })
                        }
                    </Carousel>
                    <div className="slides">
                        {
                            this.state.banner.map((item,index)=>{
                                return <div onClick={(ev)=>{ev.stopPropagation();this.gotoSlide(index)}} key={index} className={this.state.currentIndex === index?'hover':''}></div>
                            })
                        }
                    </div>
                </div>
                


                {
                    this.state.data.map((item,index)=>{
                        return <div key={index}>
                                    <div className="page1" hidden={item.type !== 0}>
                                        <div className="cen">
                                            <div className="pmain">
                                                <div className="cont" dangerouslySetInnerHTML={{
                                                    __html: item.info
                                                }}></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="page1" hidden={item.type !== 1}>
                                        <div className="cen">
                                            <div className="pmain">
                                                <div className="title">
                                                    <h1>{item.title_en}</h1>
                                                    <div className="cen">
                                                        <div className="ts"></div>
                                                    </div>
                                                    <p>{item.title_zh}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pinfo">
                                            <div className="cen">
                                                <div className="pcont">
                                                    <div className="cont" dangerouslySetInnerHTML={{
                                                        __html: item.info
                                                    }}></div>
                                                    </div>
                                                </div>
                                        </div>
                                        <div className='cen'>
                                            {
                                                item.type === 1?<div className="p_banner" id="swpierBox">
                                                <div className="pswiper">
                                                    {
                                                        this.state.showSwiper&&item.type === 1?<Swiper
                                                        
                                                        history = { true}
                                                        slidesPerView = {3}
                                                        spaceBetween = {0}
                                                        loop={true}
                                                        onSlideChange={() => this.handleSlideChange()}
                                                        onSwiper={(swiper) => {
                                                            let activeIndex = swiper.activeIndex;
                                                        }}
                                                        >
                                                        {
                                                            item.type === 1&&item.image?item.image.map((elem,num)=>{
                                                                return <SwiperSlide key={num} virtualIndex={num}>
                                                                            <div className="item" style={{backgroundImage:"url('"+elem+"')"}}>

                                                                            </div>
                                                                        </SwiperSlide>
                                                            }):null
                                                        }


                                                    </Swiper>:null
                                                    }
                                                </div>
                                                <div className="pslide">
                                                    {
                                                        item.type === 1?item.image.map((item,index)=>{
                                                            return <div className={this.state.activeIndex%3 === index?"dw2":""}></div>
                                                        }):null
                                                    }
                                                </div>
                                            </div>:null
                                            }
                                        </div>
                                    </div>


                                    <div className="page2" hidden={item.type !== 2}>
                                        <div className="cen">
                                            <div className="pmain">
                                                <div className="title">
                                                    <h1>{item.title_en}</h1>
                                                    <div className="cen">
                                                        <div className="ts"></div>
                                                    </div>
                                                    <p>{item.title_zh}</p>
                                                </div>

                                                <div className="pinfo">
                                                    <div className="pleft" style={{backgroundImage:"url('"+item.image+"')"}}></div>
                                                    <div className="pright">
                                                        {
                                                            item.type === 2?item.city_list.map((elem,num)=>{
                                                                return <div className="pri" key={num}>
                                                                            <img alt="" src="/www/assets/imgs/dingwei.png" />
                                                                            <p>{elem.title}{elem.city}</p>
                                                                        </div>
                                                            }):null
                                                        }
                                                        <button onClick={()=>{
                                                            
                                                            // if(!get('token')){  
                                                            //     message.info("请先登录");
                                                            //     this.gotoPage('/login')
                                                            //     return false;
                                                            // }

                                                            this.gotoPage('/productSignup?id='+this.state.id)}}>立即报名</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="page3" style={{backgroundImage:"url('/www/assets/imgs/beijing2.png')"}} hidden={item.type !== 3}>
                                        <div className="cen">
                                            <div className="pmain">
                                                <div className="title2">
                                                    <h1>{item.title_en}</h1>
                                                    <div className="cen">
                                                        <div className="ts"></div>
                                                    </div>
                                                    <p>{item.title_zh}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pinfo">
                                            <div className="pbs">
                                                <div className="pcen">
                                                    <div className="pdiv">
                                                        <div className="p1" style={{backgroundImage:"url('/www/assets/imgs/liubianxing.png')"}}>
                                                            <h2>{item.type === 3?item.saicheng[0].title:""}</h2>
                                                            <div className="cen">
                                                                <span></span>
                                                            </div>
                                                            <p>{item.type === 3?item.saicheng[0].info:""}</p>
                                                        </div>
                                                        <div className="pp">
                                                            <img alt="" src="/www/assets/imgs/jiantou.png" />
                                                            <img alt="" src="/www/assets/imgs/jiantou.png" />
                                                            <img alt="" src="/www/assets/imgs/jiantou.png" />
                                                            <h2>{item.type === 3?item.saicheng[1].title:""}</h2>
                                                            <p>{item.type === 3?item.saicheng[1].info:""}</p>
                                                        </div>
                                                        <div className="p2" style={{backgroundImage:"url('/www/assets/imgs/liubianxing.png')"}}>
                                                            <div className="ptime">
                                                                <p>{item.type === 3?item.saicheng[2].info_t:""}</p>
                                                                <div className="cen">
                                                                    <span></span>
                                                                </div>
                                                                <h2>{item.type === 3?item.saicheng[2].title:""}</h2>
                                                                <div className="cen">
                                                                    <span></span>
                                                                </div>
                                                                <p>{item.type === 3?item.saicheng[2].info:""}</p>
                                                            </div>
                                                        </div>
                                                        <div className="pp">
                                                            <img alt="" src="/www/assets/imgs/jiantou.png" />
                                                            <img alt="" src="/www/assets/imgs/jiantou.png" />
                                                            <img alt="" src="/www/assets/imgs/jiantou.png" />
                                                            <h2>{item.type === 3?item.saicheng[3].title:""}</h2>
                                                            <p>{item.type === 3?item.saicheng[3].info:""}</p>
                                                        </div>
                                                        <div className="p1" style={{backgroundImage:"url('/www/assets/imgs/liubianxing.png')"}}>
                                                            <h2>{item.type === 3?item.saicheng[4].title:""}</h2>
                                                            <div className="cen">
                                                                <span></span>
                                                            </div>
                                                            <p>{item.type === 3?item.saicheng[4].info:""}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="page4" hidden={item.type !== 4}>
                                        <div className="cen">
                                            <div className="pmain">
                                                <div className="title">
                                                    <h1>{item.title_en}</h1>
                                                    <div className="cen">
                                                        <div className="ts"></div>
                                                    </div>
                                                    <p>{item.title_zh}</p>
                                                </div>
                                                <div className="pbox">
                                                    {
                                                        item.type === 4?item.list.map((elem,num)=>{
                                                            return <div className={num%2?"pbi pbi2":"pbi"} key={num}>
                                                                        <div className="pbt">
                                                                            <div className="pb_name" style={{backgroundImage:"url('/www/assets/imgs/guizezhuangshi1.png')"}}>
                                                                                <img alt="" src={elem.image} hidden={!elem.image} />
                                                                                <p>{elem.title}</p>
                                                                            </div>
                                                                            <div className="pb_img">
                                                                                <img alt="" src="/www/assets/imgs/guizezhuangshi2.png" />
                                                                                <img alt="" src="/www/assets/imgs/guizezhuangshi2.png" />
                                                                                <img alt="" src="/www/assets/imgs/guizezhuangshi2.png" />
                                                                            </div>
                                                                        </div>
                                                                        <div className="pbom">
                                                                            {
                                                                                item.type === 4?elem.info.map((i,n)=>{
                                                                                    return <div className="pmi" key={n}>
                                                                                                <div className="psd">
                                                                                                    <div></div>
                                                                                                </div>
                                                                                                <p>{i}</p>
                                                                                            </div>
                                                                                }):null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                        }):null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    
                                    <div className="page5" hidden={item.type !== 5}>
                                        <div className="cen">
                                            <div className="pmain">
                                                <div className="title">
                                                    <h1>{item.title_en}</h1>
                                                    <div className="cen">
                                                        <div className="ts"></div>
                                                    </div>
                                                    <p>{item.title_zh}</p>
                                                </div>
                                                <div className="pbox">
                                                    {
                                                        item.type === 5?item.list.map((elem,num)=>{
                                                            return <div className="pitem" key={num} style={{backgroundImage:"url('"+elem.image+"')"}}>
                                                                        <div className="cen">
                                                                            <img alt="" src={elem.icon} hidden={!elem.icon} />
                                                                        </div>
                                                                        <h2>{elem.title}</h2>
                                                                        <div className="cen">
                                                                            <span></span>
                                                                        </div>
                                                                        <div className="cen">
                                                                            <p>{elem.text}</p>
                                                                        </div>
                                                                    </div>
                                                        }):null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="page6" hidden={item.type !== 6}>
                                        <div className="cen">
                                            <div className="pmain">
                                                <div className="title">
                                                    <h1>{item.title_en}</h1>
                                                    <div className="cen">
                                                        <div className="ts"></div>
                                                    </div>
                                                    <p>{item.title_zh}</p>
                                                </div>
                                                <div className="pbox">
                                                    {
                                                        item.type === 6?item.list.map((elem,num)=>{
                                                            return <div className="pitem">
                                                                        <img alt="" src={elem.icons} hidden={!elem.icons} />
                                                                        <div className="pright">
                                                                            <h2>{elem.title}</h2>
                                                                            <div>
                                                                                <p>{elem.text}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                        }):null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="page7" hidden={item.type !== 7}>
                                        <div className="cen">
                                            <div className="pmain">
                                                <div className="title">
                                                    <h1>{item.title_en}</h1>
                                                    <div className="cen">
                                                        <div className="ts"></div>
                                                    </div>
                                                    <p>{item.title_zh}</p>
                                                </div>
                                                <div className="pinfo">
                                                    <div className="pleft">
                                                        <Map amapkey={'42eb15c1f2a44772a9d032729e8ca3f1'} center={this.state.position} zoom={20}>
                                                            <Marker position={this.state.position} />
                                                        </Map>
                                                    </div>
                                                    <div className="pspan"></div>
                                                    <div className="pright">
                                                        <div className="pitem">
                                                            <img alt="" src="/www/assets/imgs/youjian.png" />
                                                            <p>{item.title}</p>
                                                        </div>
                                                        <div className="pitem">
                                                            <img alt="" src="/www/assets/imgs/dizhi.png" />
                                                            <p>{item.address}</p>
                                                        </div>
                                                        <div className="pitem">
                                                            <img alt="" src="/www/assets/imgs/wangzhi.png" />
                                                            <p>{item.url}</p>
                                                        </div>
                                                        <button className={this.state.type === 2?"cblack":""} onClick={()=>{
                                                            
                                                            if(this.state.type === 2){
                                                                message.info("报名已结束");
                                                                return false;
                                                            }
                                                            
                                                            // if(!get('token')){  
                                                            //     message.info("请先登录");
                                                            //     this.gotoPage('/login')
                                                            //     return false;
                                                            // }
                                                            
                                                            this.gotoPage('/productSignup?id='+this.state.id)}}>{this.state.type === 2?"报名已结束":"报名"}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                    })
                }

                

                <div className="cen">
                <button className={this.state.type === 2?"cbt cblack":"cbt"} onClick={()=>{

                    if(this.state.type === 2){
                        message.info("报名已结束");
                        return false;
                    }
                    
                    // if(!get('token')){  
                    //     message.info("请先登录");
                    //     this.gotoPage('/login')
                    //     return false;
                    // }

                    this.gotoPage('/productSignup?id='+this.state.id)}}>{this.state.type === 2?"报名已结束":"报名"}</button>
                </div>

                

                

                

                


                

                <div className="page8" hidden>
                    <div className="cen">
                        <div className="pmain">
                            <div className="title">
                                <h1>VIDEO</h1>
                                <div className="cen">
                                    <div className="ts"></div>
                                </div>
                                <p>赛事<span>VIDEO</span></p>
                            </div>

                            <div className="pvideo">
                                {
                                    this.state.list.map((item,index)=>{
                                        return <div className="pv" key={index}>
                                                    <div className="ptop">
                                                        <video onPlay={()=>{this.gotoShowDetails(item)}} controls src={item.path}></video>
                                                    </div>
                                                    <div className="pbom">
                                                        <h1>“创启未来”2019年国际青年科技创业大赛-人工智能专项赛事</h1>
                                                        <span></span>
                                                        <div className="pnum">
                                                            <div>
                                                                <img alt="" src="/www/assets/imgs/num.png" />
                                                                <p>3281</p>
                                                            </div>
                                                            <div>
                                                                <img alt="" src="/www/assets/imgs/time.png" />
                                                                <p>2021/08/20</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                    })
                                }
                            </div>
                        </div>

                        
                    </div>
                </div>

                
                {/* <div className="share">
                    <div className="scen">
                        <div className="sbtns">
                            <div className="sbi" onClick={()=>{this.setState({alert:true})}}>
                                <img alt="" src="/www/assets/imgs/weixin.png" />
                            </div>
                            <div className="sbi" onClick={()=>{window.scroll(0,0)}}>
                                <img className="img" alt="" src="/www/assets/imgs/zhiding.png" />
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="alert" hidden={!this.state.alert}>
                    <div className="abox">
                        <div className="adiv">
                            <div className="at">
                                <h2>微信扫码打开分享</h2>
                            </div>
                            <div className="ama">
                                <div>
                                <QRCode
                                    value={this.state.share_url}  //value参数为生成二维码的链接
                                    size={180} //二维码的宽高尺寸
                                    fgColor="#000000"  //二维码的颜色
                                />
                                </div>
                            </div>
                        </div>
                        <div className="cen">
                            <img alt="" onClick={()=>{this.setState({alert:false})}} src="/www/assets/imgs/chacha.png" />
                        </div>
                    </div>
                </div>


                <Footer />
            </div>
        )
    }
}
